Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.MultitouchInputMode = module.exports.default = {
	GESTURE: "gesture",
	NONE: "none",
	TOUCH_POINT: "touchPoint"
};